import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Magic 8-Ball Analytics',
		description:
			'Replace all market analysis with Magic 8-Ball predictions. Surprisingly accurate!'
	},
	{
		name: 'Astrology Trading',
		description:
			'Base all market predictions on zodiac signs and planetary alignments.'
	},
	{
		name: 'Time Paradox Trading',
		description: "Trade based on tomorrow's newspaper headlines from yesterday."
	},
	{
		name: 'Dream Analysis Algorithm',
		description:
			"Generate market forecasts based on employees' recurring nightmares."
	},
	{
		name: 'Quantum Probability Engine',
		description:
			'Calculate odds using quantum superposition. All bets are simultaneously won and lost.'
	},
	{
		name: 'Multiverse Betting',
		description:
			'Accept bets from infinite parallel universes. Infinite loss potential!'
	},
	{
		name: 'Chaos Theory Gambling',
		description:
			'Let butterfly effects determine all market outcomes. What could go wrong?'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Prediction Market'],
	departments[DepartmentIds['Prediction Market']].basePrice * 3,
	UpgradeIds.PdmExponent1
)

export default array
